export enum CardItemType {
    PENDING_COMMITMENTS = 0,
    COACHED,
    UNCOACHED,
}
